var r=function(r,a){var n,t;return r&&a?(n=Math.min(r/a*100,100),t=Math.min(a/r*100,100)):r?(n=100,t=0):a&&(t=100,n=0),{actualBarPercent:t,designBarPercent:n}};export{r as getBarPercents};
